function v(version: string) {
  const splitted = version.split('.');
  return `${splitted[0]}.${splitted[1] ?? '0'}`;
}

export const version = v(import.meta.env.VITE_APP_VERSION || '1.0');
export const build = import.meta.env.VITE_APP_BUILD_NUMBER || '0';
